import { isDefined, type CompanyId, type RoleGetSuccess } from '@terros/common'
import { mergeGetHookResponses, type GetHookResponse } from '../hooks'
import { useRole } from './get'
import { useRoles } from './list'

export const useAdminRole = (companyId?: CompanyId, enabled = true): GetHookResponse<RoleGetSuccess> => {
  const { data, ...rolesState } = useRoles({ companyId, enabled })
  const adminRole = data?.find((role) => role.roleType === 'admin')

  const {
    data: role,
    lastUpdatedAt,
    ...adminRoleState
  } = useRole({ roleId: adminRole?.roleId, extended: true }, isDefined(adminRole))

  return {
    data: role,
    lastUpdatedAt: rolesState.lastUpdatedAt,
    ...mergeGetHookResponses([rolesState, adminRoleState]),
  }
}
